export const SET_WALLET_VALUES = 'SET_WALLET_VALUES';
export const RESET_WALLET_VALUES = 'RESET_WALLET_VALUES';
export const INIT_WALLET_CONNECT = 'INIT_WALLET_CONNECT';

export const SET_DEPOSIT_LOADING = 'DEPOSIT_LOADING';
export const SET_DEPOSIT_SUCCESS = 'DEPOSIT_STATUS';
export const SEND_DEPOSIT = 'SEND_DEPOSIT';
